{
  "title": "Postfächer",
  "subtitle": "Aus dem Verzeichnis gespiegelte Postfächer und die Signatur, die jedes erhält.",
  "listIntro": "Aus dem Kundenverzeichnis gespiegelt. Personen erscheinen hier automatisch innerhalb von etwa fünfzehn Minuten nach der Erstellung in Microsoft 365.",
  "searchPlaceholder": "Name oder Adresse suchen",
  "defaultTemplate": "Standardsignatur",
  "defaultIntro": "Wird auf jedes Postfach angewendet, das nichts Spezifischeres hat. Operatorregeln und Gruppensignaturen überschreiben sie; eine hier für eine Person gesetzte Signatur überschreibt beides.",
  "noPublishedTemplates": "Noch keine veröffentlichten Vorlagen. Veröffentlichen Sie eine im Tab Signaturen, dann kann sie zum Mandantenstandard werden.",
  "newMessages": "Neue Nachrichten",
  "noDefault": "Kein Standard gesetzt",
  "repliesForwards": "Antworten und Weiterleitungen",
  "sameAsNew": "Wie bei neuen Nachrichten",
  "saveDefault": "Standard speichern",
  "defaultCleared": "Standard gelöscht. Postfächer, die ihm folgten, werden nicht mehr gestempelt.",
  "defaultSaved": "Standard gespeichert und auf alle Postfächer angewendet.",
  "saveFailed": "Konnte nicht gespeichert werden.",
  "noMailboxesCovered": "Noch keine Postfächer abgedeckt.",
  "coveredCount": "{{count}} Postfach abgedeckt.",
  "coveredCount_other": "{{count}} Postfächer abgedeckt.",
  "coveredWithCustom": "{{covered}} Postfächer abgedeckt, {{custom}} mit individuell gesetzter Signatur.",
  "setDefault": "Standard festlegen",
  "colPerson": "Person",
  "colSignature": "Signatur",
  "colNewMessages": "Neue Nachrichten",
  "colRepliesForwards": "Antworten & Weiterleitungen",
  "previewNewAria": "Vorschau der Signatur für neue Nachrichten {{name}}",
  "previewReplyAria": "Vorschau der Antwortsignatur {{name}}",
  "colStamped": "Gestempelt",
  "colSidebar": "Seitenleiste",
  "colAllowChanges": "Änderungen erlauben",
  "colExcluded": "Ausgeschlossen",
  "selectAllVisible": "Alle sichtbaren Postfächer auswählen",
  "selectUser": "{{email}} auswählen",
  "emptySearch": "Niemand entspricht dieser Suche.",
  "emptyNone": "Noch keine Postfächer synchronisiert. Verbinden Sie ein Verzeichnis im Tab Einstellungen.",
  "showingFirst200": "Die ersten 200 werden angezeigt. Suchen Sie, um die Liste einzugrenzen.",
  "addressesCount": "{{count}} Adressen",
  "noMailbox": "Kein Postfach",
  "stateCustomised": "Angepasst",
  "stateDefault": "Standard",
  "stateNotCovered": "Nicht abgedeckt",
  "stateCustom": "Benutzerdefiniert",
  "stateExcluded": "Ausgeschlossen",
  "stateRule": "Aus Regel",
  "stateGroup": "Aus Gruppe",
  "previewAria": "Signaturvorschau {{name}}",
  "stampAria": "E-Mail von {{email}} stempeln",
  "sidebarAria": "Outlook-Seitenleiste für {{email}} anbieten",
  "sidebarTitle": "Outlook-Signaturfenster für diese Person anbieten",
  "allowChangesAria": "Signaturänderungen für {{email}} erlauben",
  "allowChangesTitle": "Signatur wählen und Felder in Outlook bearbeiten lassen",
  "changeFailed": "Konnte nicht geändert werden.",
  "preview": "Vorschau",
  "whyThis": "Warum diese?",
  "fields": "Felder",
  "customise": "Anpassen",
  "revert": "Zurücksetzen",
  "revertedToDefault": "{{name}} ist wieder auf dem Mandantenstandard.",
  "unknownTemplate": "Unbekannte Vorlage",
  "signatureFallback": "Signatur",
  "massUpdate": "Massenaktualisierung",
  "massUpdateCount": "Massenaktualisierung ({{count}})",
  "selectedCount": "{{count}} ausgewählt",
  "massUpdateTitle": "Massenaktualisierung",
  "massUpdateIntro": "Eine Änderung auf {{count}} ausgewähltes Postfach anwenden.",
  "massUpdateIntro_other": "Eine Änderung auf {{count}} ausgewählte Postfächer anwenden.",
  "action": "Aktion",
  "actionPlaceholder": "Wählen Sie, was geändert werden soll",
  "actionStamp": "Stempeln (in Signaturen einbeziehen)",
  "actionUnstamp": "Stempel entfernen (von Signaturen ausschließen)",
  "actionCustomise": "Signatur anpassen",
  "actionRevert": "Auf Mandantenstandard zurücksetzen",
  "actionSidebarOn": "Outlook-Seitenleiste: aktivieren",
  "actionSidebarOff": "Outlook-Seitenleiste: deaktivieren",
  "actionAllowOn": "Outlook: Änderungen erlauben",
  "actionAllowOff": "Outlook: Einstellungen sperren (nur Vorschau)",
  "signature": "Signatur",
  "choosePublished": "Veröffentlichte Vorlage wählen",
  "skippedNoMailbox": "{{count}} ohne Postfach werden übersprungen.",
  "skippedNotCustomised": "{{count}} nicht angepasste werden übersprungen.",
  "nobodyEligible": "Niemand in der Auswahl kann diese Änderung erhalten.",
  "apply": "Anwenden",
  "updatedCount": "{{count}} Postfach aktualisiert.",
  "updatedCount_other": "{{count}} Postfächer aktualisiert.",
  "failedCount": "{{count}} Postfach konnte nicht aktualisiert werden.",
  "failedCount_other": "{{count}} Postfächer konnten nicht aktualisiert werden.",
  "partialUpdate": "{{succeeded}} aktualisiert, {{failed}} fehlgeschlagen.",
  "massUpdateFailed": "Diese Massenaktualisierung konnte nicht angewendet werden.",
  "customiseTitle": "Signatur für {{name}}",
  "customiseIntro": "Dies bindet ein Postfach an eine eigene Signatur. Sie hat Vorrang vor Gruppenregeln und dem Mandantenstandard und folgt dem Standard nicht mehr — auch wenn sich der Standard später ändert.",
  "setSignature": "Signatur festlegen",
  "customiseSuccess": "{{name}} hat jetzt eine eigene Signatur.",
  "customiseFailed": "Diese Signatur konnte nicht festgelegt werden.",
  "explainTitle": "Signatur für {{name}}",
  "explainIntro": "Führt dieselbe Auswertung wie der E-Mail-Pfad aus, gegen eine neue Nachricht an einen externen Empfänger.",
  "explain": "Erklären",
  "explainFailedTitle": "Test konnte nicht ausgeführt werden",
  "fieldsTitle": "Felder — {{name}}",
  "fieldsSaved": "Feldüberschreibungen gespeichert.",
  "fieldsSaveFailed": "Konnte nicht gespeichert werden.",
  "photoAria": "Foto für {{email}}",
  "photoUploaded": "Hochgeladenes Foto",
  "photoFromDirectory": "Aus dem Verzeichnis",
  "uploadPhoto": "Foto hochladen",
  "replacePhoto": "Foto ersetzen",
  "clearPhoto": "Foto löschen",
  "removeUseDirectory": "Entfernen und das aus dem Verzeichnis verwenden",
  "photoRemoved": "Foto entfernt. Die nächste Verzeichnissynchronisierung bringt ihres zurück, falls vorhanden.",
  "photoNotRemovedTitle": "Nicht entfernt",
  "photoNotRemoved": "Dieses Foto konnte nicht entfernt werden.",
  "photoUpdated": "Foto aktualisiert.",
  "photoUpdatedTitle": "Foto aktualisiert",
  "photoNotUploadedTitle": "Nicht hochgeladen",
  "photoNotUploaded": "Dieses Foto konnte nicht hochgeladen werden.",
  "photo": "Foto",
  "exclude": "Vom Stempeln ausschließen",
  "include": "In Stempeln einbeziehen",
  "editFields": "Felder bearbeiten",
  "outlookSetup": "Outlook-Add-in-Einrichtung",
  "outlook": {
    "cardTitle": "Outlook-Seitenleisten-Add-in",
    "cardIntro": "Stellen Sie das Add-in einmal über Microsoft 365 Centralized Deployment bereit und aktivieren Sie es dann pro Postfach im Tab Benutzer. Die folgenden Standards gelten nur für neu synchronisierte Postfächer.",
    "setupWizard": "Einrichtungsassistent",
    "sidebarDefault": "Seitenleiste für neue Postfächer aktivieren",
    "allowDefault": "Self-Service-Änderungen für neue Postfächer erlauben",
    "editableFields": "Felder, die Endbenutzer bearbeiten dürfen",
    "editableFieldsDesc": "z. B. Mobil, Titel. Identitätsfelder sind nie bearbeitbar.",
    "fieldPlaceholder": "Merge-Feldschlüssel hinzufügen",
    "manifestUrl": "Manifest-URL",
    "manifestCopied": "Manifest-URL kopiert.",
    "save": "Outlook-Einstellungen speichern",
    "saved": "Outlook-Seitenleisteneinstellungen gespeichert.",
    "saveFailed": "Konnte nicht gespeichert werden.",
    "gateNote": "Die Schalter Seitenleiste / Änderungen erlauben pro Postfach im Tab Benutzer steuern den Zugriff nach der Bereitstellung.",
    "wizardTitle": "Outlook-Signatur-Add-in bereitstellen",
    "wizardIntro": "Centralized Deployment installiert das Add-in für zugewiesene Microsoft-365-Benutzer. Aktivieren Sie danach Seitenleiste (und optional Änderungen erlauben) pro Postfach im Tab Benutzer — die Bereitstellung allein öffnet die Einstellungen nicht für alle.",
    "stepPrereq": "Voraussetzungen",
    "stepManifest": "Manifest-URL",
    "stepUpload": "Im Admin Center hochladen",
    "stepAssign": "Benutzer zuweisen",
    "stepEnable": "Postfächer aktivieren",
    "stepVerify": "In Outlook prüfen",
    "completeTitle": "Bereitstellungs-Checkliste abgeschlossen",
    "completeBody": "Benutzer müssen Outlook möglicherweise neu starten. Die Menübandschaltfläche kann bis zu einigen Stunden brauchen, bis sie für alle erscheint. Wenn der Bereich meldet, dass die Organisation Signatureinstellungen nicht aktiviert hat, schalten Sie Seitenleiste für dieses Postfach unter Benutzer ein.",
    "finish": "Fertigstellen",
    "beforeStart": "Bevor Sie beginnen",
    "prereqAdmin": "Melden Sie sich im Microsoft-365-Admin Center als Global Administrator oder Office Apps Administrator an.",
    "prereqOutlook": "Benutzer benötigen Exchange Online / Microsoft 365 Outlook (klassisches perpetual Outlook wird für dieses Add-in nicht unterstützt).",
    "prereqHttps": "Das reine XML-Manifest des Add-ins wird von OnBrandMail über HTTPS gehostet — fügen Sie die URL ein; Sie laden keine Datei von der Festplatte hoch.",
    "copyManifestTitle": "Manifest-URL kopieren",
    "copyManifestBody": "Microsoft validiert diesen XML-Link bei der Bereitstellung. Behalten Sie HTTPS bei und schreiben Sie den Pfad nicht um (er muss mit manifest.xml enden).",
    "uploadTitle": "Im Microsoft-365-Admin Center hochladen",
    "uploadStep1": "Öffnen Sie Einstellungen → Integrierte Apps im Admin Center.",
    "uploadStep2": "Wählen Sie Benutzerdefinierte Apps hochladen (oder Add-in bereitstellen, wenn Sie auf der Add-ins-Seite sind).",
    "uploadStep3": "Legen Sie den App-Typ auf Office-Add-in fest (nicht Teams-App).",
    "uploadStep4": "Wählen Sie Link zur Manifestdatei angeben, fügen Sie die XML-URL aus dem vorherigen Schritt ein und dann Validieren / Hochladen.",
    "uploadStep5": "Akzeptieren Sie die Berechtigungsanfragen, wenn Sie dazu aufgefordert werden, damit Outlook den Signaturbereich öffnen kann.",
    "openIntegratedApps": "Integrierte Apps öffnen",
    "pilotHint": "Bevorzugen Sie zuerst eine Pilot-Sicherheitsgruppe (dieselben Personen wie für den E-Mail-Fluss-Pilot). Sie können die Zuweisung später erweitern, ohne das Manifest erneut hochzuladen.",
    "assignTitle": "Wer das Add-in erhält",
    "assignIntro": "Die Zuweisung hier installiert nur die Outlook-Schaltfläche. Sie gewährt keinen Signatur-Self-Service — der bleibt im Tab Benutzer.",
    "assignSpecific": "Bestimmte Benutzer/Gruppen — empfohlen. Beginnen Sie mit Ihrer OnBrandMail-Pilotgruppe.",
    "assignEveryone": "Alle — in Ordnung, sobald Sie bereit sind; der Bereich zeigt weiterhin einen Leerzustand, bis Seitenleiste für dieses Postfach aktiviert ist.",
    "assignJustMe": "Nur ich — nützlich, um das Menüband zu prüfen, bevor Sie die Einführung erweitern.",
    "assignDeploy": "Wählen Sie Bereitstellen / Bereitstellung abschließen, wenn der Assistent fragt. Microsoft kann Minuten bis Stunden brauchen, bevor die Schaltfläche für jeden Zugewiesenen erscheint.",
    "enableTitle": "Postfächer in OnBrandMail aktivieren",
    "enableIntro": "Centralized Deployment ist organisationsweit; OnBrandMail steuert die Erfahrung pro Person.",
    "enableStep1": "Öffnen Sie den Tab Benutzer für diesen Mandanten.",
    "enableStep2": "Schalten Sie Seitenleiste für jedes Pilotpostfach ein (oder verwenden Sie Massenaktualisierung → Outlook-Seitenleiste: aktivieren).",
    "enableStep3": "Aktivieren Sie optional Änderungen erlauben, damit diese Personen eine Vorlage wählen und gesteuerte Felder bearbeiten können. Lassen Sie es für nur Vorschau aus.",
    "enableStep4": "Mandantenadministratoren erhalten für ihr eigenes Postfach immer den erweiterten Bereich, auch wenn Seitenleiste aus ist.",
    "enableDefaultsNote": "Standards auf dieser Einstellungen-Karte gelten nur für neu synchronisierte Postfächer. Bestehende Personen brauchen die Benutzer-Schalter (oder Massenaktualisierung).",
    "verifyTitle": "In Outlook prüfen",
    "verifyStep1": "Starten Sie das neue Outlook / Outlook im Web für einen Pilotnutzer neu.",
    "verifyStep2": "Öffnen Sie eine Nachricht oder ein Verfassen-Fenster und suchen Sie die Schaltfläche Signatur im Menüband.",
    "verifyStep3": "Der Bereich sollte ihre Vorschau und „warum diese Signatur“ zeigen. Wenn Einstellungen gesperrt sind, ist das erwartet, wenn Änderungen erlauben aus ist.",
    "verifyStep4": "Als Mandantenadministrator bestätigen Sie, dass der Admin-Streifen und die Postfachsuche erscheinen, wenn Sie den Bereich selbst öffnen.",
    "verifyManifestHint": "Wenn die Validierung der Manifest-URL im Admin Center fehlschlägt, bestätigen Sie, dass die URL XML (OfficeApp) über HTTPS aus einem Browser außerhalb Ihres Netzwerks zurückgibt.",
    "theUrl": "die URL"
  }
}
